import { IBrandingOverrides } from 'src/branding/types';

export interface FilteredStatus {
  label: string;
  key?: string;
  value?: string;
  id: string;
}

export const filterAllowedStatus = (
  statuses: FilteredStatus[],
  branding: IBrandingOverrides
): FilteredStatus[] => {
  if (!branding.permissions.serviceRequestStatus.current) {
    return statuses;
  }
  return statuses.filter(
    (s: FilteredStatus) =>
      branding.permissions.serviceRequestStatus.current[s.id] ?? true
  );
};
